import img101 from "../images/resource/subjects/mgimg_heart.jpg";

//import img1 from "../images/title/visual_greeting.jpeg";
import img1 from "../images/title/visual_mri.jpg";
import titleImg1 from "../images/resource/images/스카이MRI실.jpeg";
import titleImg2 from "../images/resource/subjects/radioimg_1.jpg";
import titleImg3 from "../images/resource/subjects/DSC06707.jpg";
import titleImg4 from "../images/resource/subjects/DSC06707.jpg";
import titleImg5 from "../images/resource/subjects/gsimg_gs.jpg";
import titleImg6 from "../images/resource/subjects/피부호르몬_2026051501.jpg";
// import sec2img from "../images/resource/subjects/스카이MRI실.jpeg";

import sec3img1 from "../images/wj/DSC07315.png";
import sec3img11 from "../images/wj/DSC07336.png";
// import sec3img2 from "../images/resource/subjects/section3_img02.png";
// import sec3img3 from "../images/resource/subjects/section3_img03.png";
import sec3img333 from "../images/wj/DSC07336.png";
import sec3img21 from "../images/resource/images/DSC06699.jpg";
import sec3img22 from "../images/wj/엑스레이.png";
import sec3img31 from "../images/resource/subjects/sec3/3-1.jpg";
import sec3img334 from "../images/wj/24h.jpg";
// import sec3img32 from "../images/resource/subjects/sec3/3-2.jpg";
import sec3img32 from "../images/wj/DSC07299.png";
// import sec3img33 from "../images/resource/subjects/sec3/3-3.jpg";
import sec3img41 from "../images/wj/veterinarian-examining-cute-dog-on-white-backgroun-2023-11-27-05-36-29-utc.jpg";
// import sec3img42 from "../images/resource/subjects/sec3/4-2.jpg";
import sec3img42 from "../images/kj/차트작성.png";
import sec3img43 from "../images/kj/항암후드.png";
import sec3img051 from "../images/resource/subjects/sec3/5-01.jpg";
import sec3img052 from "../images/resource/subjects/sec3/5-02.jpg";
import sec3img053 from "../images/resource/subjects/sec3/5-03.jpg";
import sec3img054 from "../images/resource/subjects/sec3/5-04.jpg";
// import sec3img52 from "../images/resource/subjects/sec3/5-2.jpg";
import sec3img52 from "../images/kj/입원실애기.png";
import sec3img53 from "../images/kj/대화.png";

import sec3img2 from "../images/kj/마취장비.png";
// import sec3img3 from "../images/resource/images/263A9166.png";
import sec3img3 from "../images/wj/DSC07315.png";
// import sec3img33 from "../images/resource/images/263A9154.png";
import sec3img33 from "../images/wj/DSC00079.png";
import equip1 from "../images/resource/subjects/equip/image1.png";
import equip2 from "../images/resource/subjects/equip/image2.png";
import equip3 from "../images/resource/subjects/equip/image3.png";
import equip4 from "../images/resource/subjects/equip/리가슈어.jpeg"; // 리가슈어
import equip5 from "../images/resource/subjects/equip/image5.png"; // 씨암
import equip6 from "../images/resource/subjects/equip/cv70.jpeg"; // 내시경 OLYMPUS
import equip7 from "../images/resource/subjects/equip/내시경.png"; // 다목적 연성 내시경
import equip8 from "../images/resource/subjects/equip/elf-dl-a.png"; // 항암 후드 ELF-DL-A
import equip9 from "../images/wj/산소.png"; // 산소
import equip10 from "../images/wj/이물.png"; // 위세척

import surgery1 from "../images/resource/subjects/surgery_01.jpeg";

const centerInfo = [
  {
    id: 1,
    primaryImg: img101,
    titleImg: titleImg1,
    vetMemberIdx: [1, 9],
    title: "영상진단센터",
    enTitle: "MRI & CT Center",
    subTitle: `대학병원급 최첨단 진단 장비
마취과 담당의 근무
지역병원 MRI, CT 의뢰`,
    sec2: [
      {
        title1: "완벽한 진단과 치료를 위한 시작점",
        title2: "SKY 영상진단센터",
        description: `영상진단센터에서는 방사선, 초음파 및 CT, MRI와 같은 최첨단 영상장비를 통해 정확한 진단을 치료의 시작점으로 삼고 있습니다. 최상의 마취 장비와 전문 마취 의료진이 영상 검사에 참여하고 있으며, 대학병원급 영상 의료진이 소견을 판독하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img11,
        title: "풍부한 경험의 영상 의료진",
        enTitle: "",
        content: `원주스카이동물메디컬센터의 영상 의료진은 대학병원에서의 수련을 바탕으로 수많은 영상 케이스 판독을 진행하고 있습니다. 경험을 통해 축적된 노하우로 정밀한 진단이 가능합니다.`,
      },
      {
        img: sec3img2,
        title: "최상의 마취 환경",
        enTitle: "",
        content: `GE사의 Healthcare 9100cc NXT 장비를 보유하고 있으며 전문 마취 의료진이 영상 촬영을 위한 마취를 모니터링하고 있습니다. 영상 검사를 위해 마취를 해야하는 동물 의료의 특성에 맞춰 안전한 마취를 위해 항상 노력하고 있습니다.`,
      },
      {
        img: sec3img3,
        title: "진단과 치료의 연속성",
        enTitle: "",
        content: `정밀한 진단 이후에도 본원의 내과 및 외과의 협진을 통해 치료 및 수술까지 진행 가능합니다. 최선의 치료를 위하여 각고의 노력을 기울이고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip3,
        name: "GE VIVID T9 초음파",
        description:
          "심장질환 진단에 특화되어 있는 초음파로서 AI 알고리즘을 이용한 자동화된 프로세스를 갖추고 있습니다. 심장 자동 도플러, 2D-LV 자동 측정을 통해 검사 속도를 높이고 검사 결과의 재현을 최대화시킬 수 있습니다.",
      },
      {
        img: equip2,
        name: "GE Revolution ACT 32-slice MDCT",
        description:
          "적은 방사선량, 짧은 스캔 시간을 통해서도 고해상도의 영상을 최소 피폭량으로 촬영 가능합니다. 또한 CT 촬영 전용 특수 조영 장비를 통하여 체내 조영제 분포를 초단위로 구분하여 진단에 활용하고 있습니다.",
      },
      {
        img: equip1,
        name: "GE Signa Creator 1.5T MRI",
        description:
          "영상의 질을 결정하는 중요한 요소인 자장의 균질성이 뛰어나고, 강력한 경사코일, 고출력 software를 갖추고 있어, 뇌, 뇌혈관, 두경부, 척추, 무릎 관절 등에 대한 최상의 영상을 제공합니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "최선의 치료는 정밀한 진단에서 시작됩니다.",
      description: `말로 표현하지 못하는 반려동물의 치료를 위해서는 정확한 진단이 매우 중요합니다. 말하지 않아도 원인을 찾아내고 환부를 찾아내는 영상 진단은 진단의 핵심이라 할 수 있습니다.

원주스카이동물메디컬센터는 도내에서 선도적으로 CT, MRI장비를 보유 및 촬영하여 다양한 케이스를 바탕으로 경험을 축적하였습니다.

이런 경험을 바탕으로 최고의 진단 및 의료서비스를 제공하도록 하겠습니다.`,
    },
  },
  {
    id: 2,
    primaryImg: img101,
    titleImg: titleImg2,
    vetMemberIdx: [2, 5, 6, 7],
    title: "정형신경센터",
    enTitle: "Orthopedic & Neurological Surgery center",
    subTitle: `경험 많은 의료진의 수술집도
최신의 수술장비 및 마취장비 사용
최신의 멸균 시스템 적용`,
    sec2: [
      {
        title1: "정밀하게 세밀하게",
        title2: "SKY 정형신경센터",
        description: `정형, 신경수술의 특성 상 세밀한 오차에도 예후가 달라질 수 있습니다. 원주스카이동물메디컬센터는 외과를 전문으로 하는 경험많은 수의사가 수술을 직접 집도하고 있습니다. 수술 이후에 최선의 결과를 낼 수 있도록 노력하고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img1,
        title: "외과학전공의 및 수술 전문팀",
        enTitle: "",
        content: `외과학 석/박사 출신의 수의사가 상주하고 있으며 모든 수술의 집도를 담당하여 성공률을 높이고 있으며, 수술 전담 테크니션과 구성된 수술팀이 항시 수술실과 수술장비의 멸균 및 소독에 힘쓰고 있습니다.`,
      },
      {
        img: sec3img22,
        title: "철저한 수술 전 검사",
        enTitle: "",
        content: `치밀한 수술 전 검사를 통해 반드시 필요한 수술만을 실시하는 것을 지향하고 있습니다. 영상진단센터 및 내과센터의 사전 체크 후, 수술에 임하고 있습니다.`,
      },
      {
        img: sec3img33,
        title: "수술 후 관리",
        enTitle: "",
        content: `수술 이후 관리 또한 수술 못지 않게 중요합니다. 원주스카이동물메디컬센터는 내과와의 긴밀한 협진으로 수술 성공률을 올리기 위해 노력하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip5,
        name: "C-arm 메디슨 MCA-6200",
        description:
          "뼈와 관절을 연속적으로 투시하는 디지털 방사선촬영 장비입니다. 100만 화소의 고해상도 카메라와 9인치 렌즈를 적용하여 영상의 왜곡을 최소화하였습니다. 정형 수술시, 관절 및 골 병변부의 정확한 접근이 가능합니다.",
      },
      {
        img: equip4,
        name: "리가슈어(LigaSure)",
        description:
          "리가슈어는 전기에너지를 고주파에너지로 변환해 수술 시 봉합, 절개, 고정, 절제 등을 한번에 진행할 수 있는 수술용 전파 절삭기입니다. 봉합, 절개, 고정, 절제는 대부분의 수술에서 요구되는데, 전파 절삭기는 그 과정에서 혈액 손실을 줄이고 수술 시간을 단축시키며 환자의 빠른 회복을 도와줍니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "정형, 신경외과 수술은 전문 의료 영역입니다.",
      description: `정형, 신경외과 수술은 수의사 중에서도 고도로 훈련된 수의사의 집도가 고난이도 수술입니다.

원주스카이동물메디컬센터는 수의외과 석/박사 의료진이 직접 수술을 집도하고 있으며 수술 후 처치 또한 경험 많은 수의사가 직접 관리하고 있습니다.

최고의 수술을 위하여 항상 노력하는 원주스카이동물병원입니다.`,
    },
  },
  {
    id: 3,
    primaryImg: img101,
    titleImg: titleImg3,
    vetMemberIdx: [8, 10, 11, 12, 13, 18],
    title: "내과질환센터",
    enTitle: "Internal Medicine Center",
    subTitle: `24시간 icu 입원관리를 통한 중증환자집중치료
최신의 바이탈 모니터링 기계 사용한 환자상태 체크
경험많은 의료진의 협업을 통한 치료`,
    sec2: [
      {
        title1: "반려동물 20세 시대를 위해",
        title2: "SKY 내과질환센터",
        description: `내과질환센터에서는 반려동물 20세 시대를 위하여 반려동물들의 수명연장과 삶의 질 향상을 목표로 노력하고 있습니다.

정확한 진단과 면밀한 모니터링을 통한 관리와 다양한 환자 상태를 고려한 내복약 처방까지 대학병원 내과 전공자의 지도 하에 진료가 이루어지고 있습니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img31,
        title: "심장, 신장질환 특화",
        enTitle: "",
        content: `심장, 신장은 긴밀하게 연결되어 있어 치료 과정에서 항상 함께 고려해야하는 장기입니다. 투여 약물의 결정은 내과 전공의 및 숙련된 수의사에 의해 이루어지며 약물 사용의 효과 및 부작용, 합병증에 대한 고지 및 충분한 설명이 이루어집니다.`,
      },
      {
        img: sec3img32,
        title: "노령성, 내분비 질환",
        enTitle: "",
        content: `반려동물의 수명이 증가함에 따라 필연적으로 노령성 질환, 내분비 질환의 발병율이 증가하고 있습니다. 환자마다 발병원인과 처한 상황이 상이하기에 이에 따른 진단과 치료도 까다로울 수 있습니다. 원주스카이동물메디컬센터에서는 환자의 상태에 맞춰 최적의 치료를 하기 위해 노력하고 보호자님들에게 안내드리고 있습니다.`,
      },
      {
        img: sec3img333,
        title: "항암 치료",
        enTitle: "",
        content: `반려동물 수명 증가에 따라 수의학에서도 종양(암) 발생빈도가 늘어나고 있습니다. 본원은 내과, 외과, 영상 협진을 통해 CT촬영, 수술, 항암치료까지 반려동물의 수명연장을 위해 노력하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip6,
        name: "내시경 OLYMPUS CV-70",
        description:
          "상부 소화기계를 가시화해서 진단 및 치료할 수 있는 장비입니다. 이물을 자주 먹는 반려동물의 특성 상 자주 사용되는 장비입니다.",
      },
      {
        img: equip7,
        name: "다목적 연성 내시경 H-steriScope",
        description:
          "반려동물의 기관지, 그리고 신체기관은 사람보다 더 좁고 작기 때문에 사용되는 내시경 또한 그에 맞게 변화해야 합니다. 본원의 다목적연성내시경은 부드럽고 말랑말랑한 소재로 되어있어 반려동물의 신체기관에 자극을 최소화합니다. 다목적연성내시경은 다양한 기구를 장착하여 귀, 비강, 기관, 방광 검사에 적용할 수 있습니다.",
      },
      {
        img: equip8,
        name: "항암 후드 ELF-DL-A",
        description:
          "다양한 항암 약물로부터 환자와 의료진의 안전을 보호하기 위해 특수 항암 후드 및 다양한 항암 장비들을 이용하고 있습니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "반려동물 내과 질환은 전문가의 영역입니다.",
      description: `말 못하는 반려동물의 특성 상 반려동물의 내과 질환은 초기에 발견되기 힘들고 진단 시에 이미 진행된 경우가 많습니다.

따라서 간단한 치료를 요하는 경우보다 엄격한 장기 관리, 입원관리를 요하는 경우가 많습니다. 여러가지 다양한 상황에 대한 고려가 필요하여 치료의 난이도가 높은 경우가 많습니다.

원주스카이동물메디컬센터는 다양한 케이스의 치료 경험을 바탕으로 능숙한 내과 전공자가 환자에게 최선의 치료를 제공하기 위해 노력하고 있습니다.`,
    },
  },
  {
    id: 4,
    primaryImg: img101,
    titleImg: titleImg5,
    vetMemberIdx: [4, 14],
    title: "응급중환자센터",
    enTitle: "Emergency Medicine Center",
    subTitle: `24시간 icu 입원관리를 통한 중증환자집중치료
최신의 바이탈 모니터링 기계 사용한 환자상태 체크
경험많은 의료진의 협업을 통한 치료`,
    sec2: [
      {
        title1: "응급환자와 중환자의 24시간 케어",
        title2: "SKY 응급중환자센터",
        description: `응급중환자센터에서는 언제 발생할지 모르는 돌발상황에서 의료공백을 느끼지 않도록 365일 24시간 중환자 케어 및 응급 환자 진료가 이루어지고 있습니다.

의료공백을 가장 크게 느끼는 야간 중에도 전문 진료팀과 간호팀이 상주하여 중환자 및 응급 환자에 대한 신속한 진단과 치료가 이루어집니다.`,
      },
    ],
    sec3: [
      {
        img: sec3img334,
        title: "24시간 공백 없는 진료",
        enTitle: "",
        content: `사고와 질환은 예측할 수 없을 때 찾아옵니다. 365일 24시간 언제든지 발생할 수 있는 중환자 및 응급환자에 대응하기 위해 전문 인력들이 상주하고 있으며, 전문 인력을 통해 예측할 수 없을 때 발생한 문제들도 의료 공백 없이 빠르게 진단하고, 치료할 수 있습니다.`,
      },
      {
        img: sec3img41,
        title: "중독 관리",
        enTitle: "",
        content: `포도, 초콜릿 등 독성물질 섭취나 벌, 뱀 등 중독 상황의 경우 응급환자의 중독 처치를 즉각으로 도울 수 있는 항뱀독소, 흡착제, 위세척 기구 등 다양한 장비를 구비하여 빠르게 대응할 수 있기 때문에 응급환자의 치료시기를 놓치지 않을 수 있습니다.`,
      },
      {
        img: sec3img1,
        title: "응급 수술 및 내시경",
        enTitle: "",
        content: `원주SKY동물메디컬센터는 응급 수의학 전문 인력이 항시 상주하고 있기 때문에 야간에도 일부 응급 수술 및 내시경 처치가 가능하며, 돌발 상황에서도 대처가 가능하도록 전문 인력들이 대비하고 있습니다.`,
      },
    ],
    equip: [
      {
        img: equip9,
        name: "OXUS RAK-U02M",
        description:
          "기존에 가지고 있던 질환이나, 응급하게 발생한 질환으로 인해 고압 산소가 필요한 응급 환자에게 고농도의 산소를 지속적으로 투여하여 산소부족으로 발생할 수 있는 여러 장기의 손상을 막을 수 있습니다.",
      },
      {
        img: equip10,
        name: "Lavage system",
        description:
          "이물질, 약물, 독극물 등 반려동물 생명에 위협을 줄 수 있는 물질을 섭식했을 경우 반려동물의 장기에 흡수되거나, 다른 장기로 이동하며 문제를 일으키기 전에 전에 몸 밖으로 배출 시킬 수 있습니다.",
      },
    ],
    // surgery: [],
    pride: {
      title: "빠른 진단과 치료의 시작이 생존을 가릅니다.",
      description: `응급중환자센터는 경련, 중독, 쇼크, 이물 등 시급을 다투는 상황에서도 야간을 포함한 24시간 내내 진단과 치료가 가능하여 빠르고 적절한 대응으로 환자의 생존율을 높이고 있습니다. 긴급한 상황에서 정확한 진단과 신속한 치료는 생명을 구하는 데 있어 매우 중요하며, 이를 통해 환자들이 안전하게 회복될 수 있도록 돕고 있습니다.

또한, 응급중환자센터는 최신 의료 장비와 기술을 갖추고 있으며, 다양한 응급 상황에 대비해 다각적인 접근을 하고 있습니다. 의료진은 높은 전문성과 풍부한 경험을 바탕으로 각 환자에게 맞춤형 치료를 제공하며, 치료 후에도 지속적인 모니터링과 관리를 통해 환자의 회복을 돕고 있습니다. 이러한 체계적인 진료 시스템은 환자의 상태를 안정시키고, 빠른 회복을 가능하게 하여 최적의 치료 결과를 이루어냅니다.`,
    },
  },
  {
    id: 5,
    primaryImg: img101,
    titleImg: titleImg6,
    vetMemberIdx: [34],
    title: "피부호르몬센터",
    enTitle: "Skin Hormone Center",
    subTitle: ``,
    sec2: [
      {
        title1: "정확하게 원인을 찾는",
        title2: "SKY 피부/호르몬센터",
        description: `가려움, 탈모, 피부염은 단순한 피부 문제가 아닌 경우가 많습니다.

원주스카이동물메디컬센터 피부/호르몬 센터는 대학 병원 출신 의료진이 피부 질환과 내분비 질환을 함께 고려하여 진단하고 있습니다.
반복되는 피부 문제의 원인을 찾고, 장기적인 관리 계획을 통해 반려동물의 삶의 질 향상을 위해 노력하고 있습니다.
`,
      },
    ],
    sec3: [
      {
        img: sec3img051,
        title: "피부질환과 호르몬질환의 통합 진료",
        enTitle: "",
        content: `피부 질환은 알레르기, 감염뿐 아니라 갑상선 질환, 부신 질환 등 다양한 내분비 질환과 연관될 수 있습니다. 피부와 호르몬을 함께 평가하여 보다 정확한 진단을 위해 노력하고 있습니다.`,
      },
      {
        img: sec3img052,
        title: "체계적인 피부 검사",
        enTitle: "",
        content: `피부 세포검사, 피부 스크래핑 검사, 진균 검사 등 다양한 검사를 통해 질환의 원인을 확인하고 있습니다. 단순 증상 완화가 아닌 원인 치료를 지향합니다.`,
      },
      {
        img: sec3img053,
        title: "만성 피부 질환 관리",
        enTitle: "",
        content: `아토피성 피부염, 반복성 외이염, 만성 피부염 등은 꾸준한 관리가 중요합니다. 보호자와의 충분한 상담을 통해 장기적인 치료 계획을 수립하고 있습니다.`,
      },
      {
        img: sec3img054,
        title: "대학병원 출신 의료진의 전문 진료",
        enTitle: "",
        content: `대학병원에서 전공의 수련 및 임상 경험을 쌓은 의료진이 진료를 담당하고 있습니다. 다양한 피부 질환과 내분비질환의 진단 경험을 바탕으로 보다 정확한 진료를 위해 노력하고 있습니다.`,
      },
    ],
    equip: [],
    // surgery: [],
    pride: {
      title: "피부 질환의 원인을 찾는 것이 치료의 시작입니다.",
      description: `피부 질환의 원인을 정확히 파악함으로써 보다 효과적인 치료가 가능해집니다. 우리는 환자와의 충분한 소통을 통해 정확한 진단과 맞춤형 치료를 제공하고 있습니다.

피부 질환은 단순한 증상 완화가 아닌 원인 치료가 중요합니다.

원주스카이동물메디컬센터 피부/호르몬 센터는 피부 질환과 호르몬 질환을 함께 고려하여 진단하고, 장기적인 관리 계획을 통해 반려동물의 삶의 질 향상을 위해 노력하고 있습니다.
      `,
    },
  },
];

export default centerInfo;
